
<template>
  <div class="index">
    <el-carousel trigger="click" :autoplay="false" height="520px" :initial-index="0">
      <el-carousel-item :key="1">
        <div class="banner">
          <img class="banner_img" src="../../assets/img/home/banner1.png" />
          <div class="banner_text_1">
            <h4>
              <span>企业劳动力管理专家</span>
            </h4>
            <h6>
              让人力更简单
            </h6>
            <div class="button_group">
              <div class="button" @click="goRegister" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>注册企业微信</span>
              </div>
              <div class="button" @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>安装到企业微信</span>
              </div>
              <!-- <div class="button" @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>企业微信登录</span>
              </div> -->
            </div>
            <div class="try" @click="goTry" style="cursor:pointer;">立即试用</div>
          </div>
        </div>

      </el-carousel-item>
      <el-carousel-item :key="2">
        <div class="banner">
          <img class="banner_img" src="../../assets/img/home/banner2.png" />
          <div class="banner_text_2">
            <h4>
              <span>制造行业</span>劳动力解决方案
            </h4>
            <div class="button_group">
              <div class="button" @click="goRegister" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>注册企业微信</span>
              </div>
              <div class="button" @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>安装到企业微信</span>
              </div>
              <!-- <div class="button" @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>企业微信登录</span>
              </div> -->
            </div>
            <div class="try" @click="goTry" style="cursor:pointer;">立即试用</div>
          </div>
        </div>

      </el-carousel-item>
      <el-carousel-item :key="3">
        <img class="banner" src="../../assets/img/home/banner_3.png" />
      </el-carousel-item>
      <!-- <el-carousel-item :key="4">
        <img class="banner" src="../../assets/img/home/banner_4.png" />
      </el-carousel-item> -->
      <!-- <el-carousel-item v-for="item in 4" :key="item">
        <h3 class="small">{{ item }}</h3>
      </el-carousel-item> -->
    </el-carousel>
    <!-- <div class="swiper-container swiper-index" id="swiper">
      Additional required wrapper
      <div class="swiper-wrapper">
        Slides page1
        <div class="swiper-slide swiper_1">
          <img class="goDown" src="../../assets/img/down.png" @click="goDown" alt="">
        </div>
        <div class="swiper-slide swiper_2">
        </div>
        <div class="swiper-slide swiper_4">
        </div>
        <div class="swiper-slide swiper_5" @click="openMore">
            
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination"></div>
    </div> -->

    <div class="index_item item1" id="item1">
      <div class="item_box">
        <div class="box_title">一体化eHR系统，让人力更简单</div>

        <div class="dingding">
          <div class="content2">
            <ul>
              <li>
                <span class="left">
                  <img src="../../assets/img/dingding/首页001.png" />
                </span>
                <div class="gap"></div>
                <span class="right">
                  <h6>
                    组织管理
                  </h6>
                  <p>通讯录与组织架构和企业微信实时同步</p>
                  <p>支持多层级的组织架构</p>
                  <p>支持实线和虚线汇报架构</p>
                  <p>支持历史版本</p>
                </span>
              </li>
              <li>
                <span class="left">
                  <h6>
                   员工管理
                  </h6>
                  <p>支持高度可配置列表视图界面</p>
                  <p>支持布尔搜索，方便快捷找到员工</p>
                  <p>支持手动添加员工</p>
                  <p>员工详情页员工明细信息高度可配置</p>
                </span>
                <div class="gap"></div>
                <span class="right">
                  <img src="../../assets/img/dingding/首页002.png" />
                </span>
              </li>
              <li>
                <span class="left">
                  <img src="../../assets/img/dingding/首页003.png" />
                </span>
                <div class="gap"></div>
                <span class="right">
                  <h6>
                   入转调离
                  </h6>
                  <p>提供入转调离全流程审批</p>
                  <p>审批表单和审批流程可按需配置</p>
                  <p>入职审批通过即同步至企业微信</p>
                  <p>离职审批通过即从企业微信删除员工</p>
                </span>
              </li>
              <li>
                <span class="left">
                  <h6>
                    排班管理
                  </h6>
                  <p>移动端、PC端多终端排班</p>
                  <p>支持导入Excel表排班、批量排班、固定班制自动排班功能</p>
                  <p>排班数据和考勤模块打通</p>
                </span>
                <div class="gap"></div>
                <span class="right">
                  <img src="../../assets/img/dingding/首页004.png" />
                </span>
              </li>
              <li>
                <span class="right">
                  <img src="../../assets/img/dingding/首页005.png" />
                </span>
                <div class="gap"></div>
                <span class="left">
                  <h6>
                    考勤报表
                  </h6>
                  <p>每日自动生成日报、月报、加班报表、假期余额报表，可随时查看及处理考勤异常</p>
                  <p>报表数据对接薪酬模块，大大减少算薪时间</p>
                </span>
              </li>
              <li>
                <span class="left">
                  <h6>
                    薪酬账套
                  </h6>
                  <p>根据不同部门，灵活配置薪酬账套，支持各类规则自定义</p>
                </span>
                <div class="gap"></div>
                <span class="right">
                  <img src="../../assets/img/dingding/首页006.png" />
                </span>
              </li>
              <li>
                <span class="right">
                  <img src="../../assets/img/dingding/首页007.png" />
                </span>
                <div class="gap"></div>
                <span class="left">
                  <h6>
                    入转调离、考勤、社保关联
                  </h6>
                  <p>打通算薪所需各模块数据，系统算薪更省心</p>
                </span>
              </li>
            </ul>
          </div>
        </div> 
     
      </div>
    </div>
    <div class="fixed_menu flex justify-content-between align-item-center" v-if=" client == 'pc'">
      <div class="menu_item menu_qrcode experience_now">
        <img class="menu_icon experience_now_icon" src="../../assets/img/home/experience_now.png" alt="">
        <div>联系客服</div>
        <div class="qrcode_box">
          <div class="qrcode">
            <img src="../../assets/img/mf_code.png" alt="">
          </div>
          客服
        </div>
      </div>
      <div class="menu_item menu_user hotline"  v-if=" client == 'pc'">
        <img class="menu_icon hotline_icon" src="../../assets/img/home/hotline.png" alt="">
        <div>客服热线</div>
        <div class="user_box">
          <div class="title">客服热线</div>
          <p>客服在线时间：工作日 09:00-18:00</p>
          <div class="phone">156-1879-3170</div>
        </div>
      </div>
      <div class="menu_item return_top" v-if=" client == 'pc'">
        <img class="menu_icon return_top" @click="toTop" src="../../assets/img/home/return_top.png" alt="">
        <div>返回顶部</div>
      </div>
    </div>
  </div>
</template>
<script>

import Swiper from 'swiper';
import gauge from '../gauge.vue';
import Counter from '../counter.vue'
import axios from 'axios';
export default {
  components: { gauge, Counter },
  data () {
    return {
      mySwiper: {},
      gaugeValue1: 0,
      gaugeValue2: 0,
      gaugeValue3: 0,
      gaugeValue4: 0,
      gaugeValue5: 0,
      gaugeValue6: 0,
      tempTop: 0,
      isReset: true,
      client:localStorage.getItem('client'),
      pre_auth_code:'',
    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "1");
    window.addEventListener("scroll", this.handleScroll);
    this.initSwiper();
    this.getPreAuthCode();
  },
  computed: {},
  methods: {
    openMore () {
      window.location.href = 'https://page.dingtalk.com/wow/dingtalk/act/dingtalk-6?wh_...nav_bgcolor=FF000000'
    },
    initSwiper () {
      this.mySwiper = new Swiper(".swiper-index", {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
      });
    },
    toTop () {
      window.scrollTo(0, 0);
    },
    goDown () {
      let swiperTop = document
        .querySelector(`#swiper`).clientHeight;
      window.scrollTo(0, swiperTop + 88);
    },
    goBuy () {
      this.$router.push({ name: 'download' });
    },
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量

      if (this.$route.name == 'index') {
        let productScroll1 = document
          .querySelector(`#item1`)
          .getBoundingClientRect().top;
        let productScroll = document
          .querySelector(`#item2`)
          .getBoundingClientRect().top;

        let isDown = scrollTop > this.tempTop;
        if (isDown) {
          // if (productScroll > 2 && this.isReset) {
          //   if (productScroll < 310) {
          //     this.gaugeValue1 = 60;
          //     this.gaugeValue2 = 80;
          //     this.gaugeValue3 = 60;
          //   } else {
          //     this.gaugeValue1 = 0;
          //     this.gaugeValue2 = 0;
          //     this.gaugeValue3 = 0;
          //     this.gaugeValue4 = 0;
          //     this.gaugeValue5 = 0;
          //     this.gaugeValue6 = 0;
          //   }
          // } else {
            this.gaugeValue1 = 60;
            this.gaugeValue2 = 80;
            this.gaugeValue3 = 60;
            this.gaugeValue4 = 80;
            this.gaugeValue5 = 75;
            this.gaugeValue6 = 80;
          // }
        } else {
          if (productScroll1 > -600) {
            this.gaugeValue1 = 0;
            this.gaugeValue2 = 0;
            this.gaugeValue3 = 0;
            this.gaugeValue4 = 0;
            this.gaugeValue5 = 0;
            this.gaugeValue6 = 0;
            this.isReset = true;
          } else {
            this.isReset = false;
          }
        }

        this.tempTop = scrollTop;
      }
    },
    goDing(){
      let url = 'https://appcenter.dingtalk.com/detail.html?goodsCode=DD_GOODS-101001048911&sig=dabf78575b0f7b9bae7fca43be1efed0'
      window.open(url,'_blank')
    },
    goQiwei(){
      let url = 'https://open.work.weixin.qq.com/appStore/app?appId=MTk3MDMyNjIzOTk5MzM1MF8xMDYzNjE2XzE%3D&source=search&delivery_from=search'
      window.open(url,'_blank')
    },
    goTry(){
      let url = 'https://open.work.weixin.qq.com/appStore/app?appId=MTk3MDMyNjIzOTk5MzM1MF8xMDYzNjE2XzE%3D&source=search&delivery_from=search'
      window.open(url,'_blank')
    },
    goRegister(){
      let url = 'https://work.weixin.qq.com/wework_admin/register_wx'
      window.open(url,'_blank')
    },
    goUse(){
      // let url = 'https://open.work.weixin.qq.com/appStore/app?appId=MTk3MDMyNjIzOTk5MzM1MF8xMDYzNjE2XzE%3D&source=search&delivery_from=search'
      // window.open(url,'_blank')
      let url = 'https://open.work.weixin.qq.com/3rdapp/install?suite_id=wwfa698a43896c6b32&pre_auth_code='+this.pre_auth_code
      +'&redirect_uri=https%3A%2F%2Fhrec.100manfen.com%2Frst%2Findex.html'
      window.open(url,'_blank')
    },//https://hrec.100manfen.com/rst/index.html
    goLogin(){
      let url = 'https://redcs.tencent.com/'
      window.open(url,'_blank')
    },
    getPreAuthCode(){
            axios.post('https://hrec.100manfen.com/forward_webfront/apiweb/get_pre_auth_code')
                 .then(res => {
                      this.pre_auth_code = res.data.result.pre_auth_code
                 })
                 .catch(err => {
                     console.error(err);
                 })
        }
  }
};
</script>

<style lang="scss">
.index {
  .el-carousel__container {
    height: 520px;
  }

  .el-carousel__item {
    height: 520px;
  }

  .el-carousel__item .banner {
    height: 100%;
  }

  .banner {
    height: 100%;
    position: relative;

    .banner_img {
      height: 100%;
    }

    .banner_text_1 {
      position: absolute;
      top: 120px;
      left: 360px;

      h4 {
        font-size: 30px;
        font-weight: 600;
        color: #1F2329;

        span:nth-child(2) {
          color: #1F2329;
        }
      }

      h6 {
        font-size: 30px;
        font-weight: 600;
        background:linear-gradient(to right,#16A4FF,#004AFF);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
        margin-top: 15px;
      }

      .button_group {
        display: flex;
        gap: 16px;
        

        .button {
          height: 40px;
          line-height: 38px;
          font-size: 14px;
          font-weight: 400;
          color: #007bff;
          padding: 0 18px;
          border: 1px solid #f8fbff;
          border-radius: 4px;
          margin-top: 40px;
          margin-bottom: 32px;
          background-color: #f8fbff;

          >img {
            width: 18px;
            height: 17px;
            vertical-align: middle;
          }

          >span {
            vertical-align: middle;
          }
          
        }
      }
      .try{
            background-color: #f8fbff;
            color: #007bff;
          }
    }

    .banner_text_2 {
      position: absolute;
      top: 150px;
      left: 360px;

      h4 {
        font-size: 30px;
        font-weight: 600;
        color: #1F2329;
        >span {
          background:linear-gradient(to right,#16A4FF,#004AFF);
          -webkit-background-clip:text;
          -webkit-text-fill-color:transparent;
          
        }
      }

       h6 {
        font-size: 30px;
        font-weight: 600;
        color: #16A4FF;
        margin-top: 15px;
      }

      .button_group {
        display: flex;
        gap: 16px;
        

        .button {
          height: 40px;
          line-height: 38px;
          font-size: 14px;
          font-weight: 400;
          color: #007bff;
          padding: 0 18px;
          border: 1px solid #f8fbff;
          border-radius: 4px;
          margin-top: 40px;
          margin-bottom: 32px;
          background-color: #f8fbff;

          >img {
            width: 18px;
            height: 17px;
            vertical-align: middle;
          }

          >span {
            vertical-align: middle;
          }
          
        }
      }
      .try{
            background-color: #f8fbff;
            color: #007bff;
          }
    }



    .try {
      width: 300px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #007bff;
      border: 1px solid #007bff;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/pages/index.vue